import React, {  } from "react";
import ImportDetailsProps from "../importDetailsProps";
import { Partner } from "features/settings/importMapping/partner";
import { SpecificRecordsCustomImportDetails } from "./SpecificRecordsCustomImportDetails";
import RecordAndLocationCustomImportDetails from "./RecordAndLocationCustomImportDetails";

const CustomImportDetails: React.FC<ImportDetailsProps> = props => {
    switch (props.partner) {
        case Partner.Agris:
        case Partner.AgVision:
        case Partner.Agvance:
            return <RecordAndLocationCustomImportDetails {...props } enableSettlementImport={props.partner === Partner.Agvance} />;
        case Partner.AgVantage:
            return <SpecificRecordsCustomImportDetails {...props} />;
        case Partner.Intellego:
            return <SpecificRecordsCustomImportDetails {...props} />;
        default:
            return <></>;
    }
}

export default CustomImportDetails;